__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-gravity-root'].baseUrl;
import GravityRoot from './components/GravityRoot';
export default GravityRoot;
;
if (!global.BROWSER) {
  GravityRoot.appConfig = Object.assign({}, GravityRoot.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
GravityRoot.appConfig = Object.assign({}, GravityRoot.appConfig, {
  providedExternals: {
    'axp-gravity-core': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.0',
      module: require('axp-gravity-core')
    },
    '@americanexpress/gravity-core': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.2.0',
      module: require('@americanexpress/gravity-core')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-gravity-root') {
  global.getTenantRootModule = () => GravityRoot;
  global.rootModuleName = 'axp-gravity-root';
}